module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    class: [_vm.$route.name !== 'landing' ? 'not-landing' : ''],
    attrs: {
      "id": "navse",
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [(_vm.phone && _vm.fax && _vm.address) ? _c('div', {
    staticClass: "container navbar-row first is-fluid",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns navbar-full first is-gapless is-mobile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column column-link is-hidden-mobile has-text-right"
  }, [(_vm.phone && _vm.fax) ? _c('div', {
    staticClass: "call font-bold",
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_vm._v("\n            Call: " + _vm._s(_vm.phone) + "   Fax: " + _vm._s(_vm.fax) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.address) ? _c('div', {
    staticClass: "address"
  }, [_vm._v("\n            " + _vm._s(_vm.address) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow navbar-menu",
    attrs: {
      "data-aos": "zoom-in",
      "data-aos-once": "true"
    },
    on: {
      "click": function($event) {
        return _vm.onToggle()
      }
    }
  }, [_c('div', {
    staticClass: "control-menu",
    class: {
      active: _vm.showNav
    }
  }, [_c('span')])])])])]) : _c('div', {
    staticStyle: {
      "height": "120px"
    }
  }, [_vm._v("\n     \n  ")]), _vm._v(" "), _c('div', {
    staticClass: "container navbar-row second is-fluid",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns navbar-full second is-gapless is-mobile is-hidden-mobile",
    staticStyle: {
      "overflow": "hidden"
    }
  }, _vm._l((_vm.navItems), function(nav, index) {
    return _c('div', {
      key: nav.name,
      staticClass: "column column-link is-hidden-mobile",
      class: {
        /* 'has-text-left': index === 0, */
        'has-text-centered': true, // index !== 0 && index !== (navItems.length - 1),
        /* 'has-text-right': index === (navItems.length - 1), */
        'is-active': _vm.$route.name === nav.name
      }
    }, [_c('a', {
      attrs: {
        "href": ("" + (nav.path))
      }
    }, [_vm._v("\n            " + _vm._s(nav.label) + "\n          ")])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column navbar-brand",
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    staticClass: "navbar-logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive logo-1",
    attrs: {
      "src": require("../assets/logo.svg"),
      "width": "85"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive logo-2 is-hidden-mobile",
    attrs: {
      "src": require("../assets/logo-text.svg"),
      "width": "360"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d98de09","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBarFull.vue
// module id = 968
// module chunks = 1